import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "../../store";
import service from "../../services/api.service";
import { Guid } from "guid-typescript";
import * as _ from "lodash";
import { plainToClass } from "class-transformer";
import { getTenantId } from "@/store/helper";
import { HighlightModel } from "../models/highlight/highlight";
import { GridOptionModel } from "../models/shared/gridOption";
let HighlightsModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    let HighlightsModule = class HighlightsModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.apiNode = "Highlight";
            this.highlights = [];
            this.highlight = null;
            this.yearlist = [];
            this.viewHighlights = [];
            this.viewHighlight = null;
            this.totalCount = 0;
            this.searchParams = null;
        }
        async GetHighlights(searchData) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.post(url, searchData);
            if (data) {
                this.ListHighlights(plainToClass(HighlightModel, data.highlights));
                this.SetTotalCount(data.totalCount);
                return data;
            }
        }
        async GetHighlightForEdit(highlightId) {
            var url = `${getTenantId()}/${this.apiNode}/edit/` + highlightId;
            let { data } = await service.get(url);
            if (data) {
                this.ListHighlight(plainToClass(HighlightModel, data.editHighlight));
                return data;
            }
        }
        async SaveHighlight(payload) {
            var url = `${getTenantId()}/${this.apiNode}/save?isDraft=${payload.isDraft}`;
            let { data } = await service.post(url, payload.highlight);
            return data;
        }
        async UpdateHighlight(payload) {
            var url = `${getTenantId()}/${this.apiNode}/update?isDraft=${payload.isDraft}`;
            let { data } = await service.post(url, payload.highlight);
            return data;
        }
        async Deletehighlight(highlightId) {
            var url = `${getTenantId()}/${this.apiNode}/delete/` + highlightId;
            let { data } = await service.delete(url);
            if (data) {
                return data;
            }
        }
        async ArchiveHighLight(payload) {
            var url = `${getTenantId()}/${this.apiNode}/archive?highlightId=${payload.highlightId}&isArchived=${payload.isArchived}`;
            let { data } = await service.post(url);
            if (data) {
                return data;
            }
        }
        async GetHighlightsForView(year) {
            var url = `${getTenantId()}/${this.apiNode}/highlightsView?year=${year}`;
            let { data } = await service.get(url);
            if (data) {
                this.ListHighlightsForView(data.highlights);
                this.ListYears(data.yearsList);
                return data;
            }
        }
        async GetHighlightsByIdForView(highlightId) {
            var url = `${getTenantId()}/${this.apiNode}/highlightsView/` + highlightId;
            let { data } = await service.get(url);
            if (data) {
                this.ListHighlightsByIdForView(data.highlight);
                return data;
            }
        }
        ListHighlightsByIdForView(highlight) {
            this.viewHighlight = highlight;
        }
        ListHighlightsForView(highlights) {
            this.viewHighlights = highlights;
        }
        ListYears(yearlist) {
            this.yearlist = yearlist;
        }
        ListHighlights(highlights) {
            this.highlights = highlights;
        }
        async SetTotalCount(totalCount) {
            this.totalCount = totalCount;
        }
        ListHighlight(highlights) {
            this.highlight = highlights;
        }
        ClearhighLight() {
            this.viewHighlight = null;
        }
        AssignSearchParams(param) {
            this.searchParams = _.cloneDeep(param);
        }
        ClearSearchParams() {
            this.searchParams = null;
        }
        AssignSearchDate(date) {
            this.searchParams = null;
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof GridOptionModel !== "undefined" && GridOptionModel) === "function" ? _a : Object]),
        __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
    ], HighlightsModule.prototype, "GetHighlights", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
    ], HighlightsModule.prototype, "GetHighlightForEdit", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], HighlightsModule.prototype, "SaveHighlight", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], HighlightsModule.prototype, "UpdateHighlight", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_d = typeof Guid !== "undefined" && Guid) === "function" ? _d : Object]),
        __metadata("design:returntype", Promise)
    ], HighlightsModule.prototype, "Deletehighlight", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], HighlightsModule.prototype, "ArchiveHighLight", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_e = typeof Promise !== "undefined" && Promise) === "function" ? _e : Object)
    ], HighlightsModule.prototype, "GetHighlightsForView", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_f = typeof Promise !== "undefined" && Promise) === "function" ? _f : Object)
    ], HighlightsModule.prototype, "GetHighlightsByIdForView", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_g = typeof HighlightModel !== "undefined" && HighlightModel) === "function" ? _g : Object]),
        __metadata("design:returntype", void 0)
    ], HighlightsModule.prototype, "ListHighlightsByIdForView", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], HighlightsModule.prototype, "ListHighlightsForView", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], HighlightsModule.prototype, "ListYears", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], HighlightsModule.prototype, "ListHighlights", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", Promise)
    ], HighlightsModule.prototype, "SetTotalCount", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_h = typeof HighlightModel !== "undefined" && HighlightModel) === "function" ? _h : Object]),
        __metadata("design:returntype", void 0)
    ], HighlightsModule.prototype, "ListHighlight", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], HighlightsModule.prototype, "ClearhighLight", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_j = typeof GridOptionModel !== "undefined" && GridOptionModel) === "function" ? _j : Object]),
        __metadata("design:returntype", void 0)
    ], HighlightsModule.prototype, "AssignSearchParams", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], HighlightsModule.prototype, "ClearSearchParams", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], HighlightsModule.prototype, "AssignSearchDate", null);
    HighlightsModule = __decorate([
        Module({ dynamic: true, store: store, name: "highlight", namespaced: true })
    ], HighlightsModule);
    return HighlightsModule;
})();
export const HighlightModule = getModule(HighlightsModule);
